<template>
  <div class="menu-auth main-panel large">
    <h1 class="panel-title">运营员权限设置</h1>
    <table-data
      :user-list="userList"
      :menu-list="menuList"
      :current-user="currentUser"
      @change-user="changeUser"
      @change-auth="changeAuth"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from "vue";
import TableData from "./TableData/TableData";
const { proxy } = getCurrentInstance();

const userList = ref([]);
const menuList = ref([]);
const currentUser = ref(null);
const isLoading = ref(false);

const getUsers = async () => {
  const res = await proxy.$api.Operation.OperaTion.username({}).catch(() => {});
  console.log(res);
  if (res?.data.code == "200") {
    userList.value = res.data.data.list;
    console.log(userList.value, "这个是用户列表");
    const firstUser = userList.value[0];
    if (firstUser) {
      const targetUserId = firstUser.users?.[0]?.id || firstUser.id;
      if (targetUserId) {
        changeUser(targetUserId);
      }
    }
  } else {
    proxy.$message.error(res?.msg || "获取用户列表失败");
  }
};

const getMenus = async (userId) => {
  const sendata = {
    userId: userId,
  };
  const res = await proxy.$api.Operation.OperaTion.userqx(sendata).catch(
    () => {}
  );
  console.log(res, "菜单返回了什么权限");
  if (res.data.code == "200") {
    res.data.data.list = res.data.data.list.map((i) => {
      i.children = i.children.map((j) => {
        j.permission = j.permission.map((perm) => ({
          ...perm,
          delflag: Boolean(perm.delflag),
          permType: perm.perName.split(":")[1] || "",
        }));
        return j;
      });
      return i;
    });
    menuList.value = res.data.data.list;
  } else {
    proxy.$message.error(res?.msg || "获取菜单失败");
  }
};

const changeUser = (id) => {
  currentUser.value = id;
  menuList.value = [];
  getMenus(id);
};

const changeAuth = async (authData) => {
  const { mainIndex, subIndex, permType, flag } = authData;
  if (!currentUser.value || isLoading.value) return;
  if (!menuList.value[mainIndex]?.children[subIndex]) return;
  const row = menuList.value[mainIndex].children[subIndex];
  const needUpdatePerms = (() => {
    if (permType === "menu") {
      return flag
        ? ["select", permType]
        : [permType, "select", "update", "delete"];
    } else if (permType === "select") {
      return flag ? [permType] : [permType, "update", "delete"];
    } else {
      return flag ? ["select", permType] : [permType];
    }
  })();

  for (const permTypeItem of needUpdatePerms) {
    const perm = row.permission.find((p) => p.permType === permTypeItem);
    if (!perm) continue;
    perm.delflag = flag;
    const submitData = {
      userId: currentUser.value,
      menuId: row.childrenId,
      content: row.childrenContent,
      name: perm.perName,
    };
    try {
      isLoading.value = true;
      const res = await proxy.$api.Operation.OperaTion[
        flag ? "addqx" : "delqx"
      ](submitData);
      console.log(res, "单次接口返回结果");
      if (!res.data.code || res.data.code !== "200") {
        proxy.$message.error(
          `【${permTypeItem}】权限${flag ? "添加" : "删除"}失败`
        );
        perm.delflag = !flag;
      }
    } catch (error) {
      proxy.$message.error(
        `【${permTypeItem}】权限${flag ? "添加" : "删除"}失败`
      );
      perm.delflag = !flag;
    } finally {
      isLoading.value = false;
    }
  }
};

onMounted(() => {
  getUsers();
});
</script>

<style lang="scss" scoped>
.panel-title {
  color: #999;
}
</style>
